import { render, staticRenderFns } from "./DynamicLinkField.vue?vue&type=template&id=7c72f8ff&"
import script from "./DynamicLinkField.vue?vue&type=script&lang=js&"
export * from "./DynamicLinkField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
